import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    backgroundColor: "#E4F5EC",
    letterSpacing: 0,
    color: "#353535",
    height: "72px",
    minWidth: "494px",
  },
  removeImage: {
    marginLeft: "15em",
    cursor: "pointer",
  },
  mobile_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    backgroundColor: "#E4F5EC",
    letterSpacing: 0,
    color: "#353535",
    height: "88px",
    width: "100%",
  },
  box: {
    padding: "16px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  name: {
    fontSize: "18px",
  },
  mobile_name: {
    width: "177px",
  },
  namePercentage: {
    fontSize: "14px",
  },
  percentage: {
    fontSize: "32px",
    fontWeight: 300,
    borderBottom: "1px solid #B3DAC6",
  },
  mobile_percentage: {
    fontSize: "28px",
    fontWeight: 300,
    borderBottom: "1px solid #B3DAC6",
  },
  sign: {
    fontSize: "21px",
    paddingLeft: "2px",
  },

  icon_container: {
    cursor: "pointer",
  },
  inputCardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  // ----------------------------------------------

  boxCard: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
  },
}));

export default useStyles;
